import { support } from "./support";
import { tedx } from "./tedx";
import { IPosition } from "../positions/IPosition.interface";

export const volunteer: IPosition[] = [support, tedx];
